import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { cloneDeep } from 'lodash';
import {
  ConfirmationService,
  MenuItem,
  Message,
  MessageService,
  TreeNode,
} from 'primeng/api';
import {
  breadcrumb,
  link,
  stat,
} from 'src/app/admin/layout/header/header.component';
import { data_fields } from 'src/app/misc/interface/data';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
  providers: [ConfirmationService],
})
export class AddComponent {
  messages: Message[] = [];
  translator:TranslatorPipe = new TranslatorPipe()
  header = this.translate('Add data');
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Add data'), link: '/admin/data/add' },
  ];

  links:any[] = [];

  stats: stat[] = [];

  myForm: FormGroup | any;
  treeData: TreeNode[] = [];
  dataType: any = [];
  fields: any = [];
  templates: any = [];
  selectedTemplete: any;
  templetModel: boolean = false;
  previewModal: boolean = false;
  finalData: any;
  dataFileds: any
  message : any = undefined
  apilink = GlobalConstants.apiURL;
  GlobalConstants = GlobalConstants;
  staticURL = GlobalConstants.staticFilesURL;
  filed: any;

  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private orgUnits: OrgUnitsService,
    public permissionService: PermissionHandlerService
  ) {
    this.myForm = this.formBuilder.group({
      name: [null, [Validators.required, Validators.minLength(3)]],
      ou: [null, [Validators.required, Validators.minLength(3)]],
      type: [null, [Validators.required]],
    });
  }

  ngOnInit() {
    console.log('DATA APIs CALLED')
    Promise.all([this.getTreeData(), this.fetchDataType(), this.fetchFiledTypes()]);
  }
  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  test() {
    this.fields = this.selectedTemplete.fields.map((item: any) => {
      return {
        label: item.name,
        type: item.type._id,  
        data: '',
        item_Id: null,
        item_Field: null,
      };
    });

    // setting all modals to false
    this.fields.forEach(() => {
      this.modalVisibilities.push(false);
    });
  }

  // async getTreeData() {
  //   this.treeData = await this.permissionService.extractOUChildren('DATA', 'c');
  //   console.log('TREE', this.treeData);
  // }

  private async fetchDataType(): Promise<void> {
    let res = await this.dataService.postData('data-type/get', {
      active: true,
    });
    console.log(res.data);
    if (res.error) {
      return;
    }

    let allowedTypes = this.permissionService.extractTags('CONTENT_UPDATE_DATA_TYPE','r');

    this.dataType = res.data
    .filter((item: any) => allowedTypes.includes(item._id))
    .map((item: any) => {
      return {
        _id: item._id,
        label: item.arabic,
        icon: `pi pi-${item.icon}`,
      };
    });
  }

  private async fetchFiledTypes(): Promise<void> {
    let res = await this.dataService.postData('data-fields/get?offset=200&page=1', { active: true });
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.dataFileds = res.data
  }

  async fetchTemplet(item: any): Promise<void> {
    let res = await this.dataService.postData('data-template/get/data', {
      active: true,
      type: item._id,
      // ou: this.myForm.value.ou._id
    });
    if (res.error) {
      return;
    }
    this.templates = res.data.data


    let temp: any = []
    this.templates.forEach((e: any) => {
      if (e.ou != null) {
        let test = e?.ou.filter((item: any) => item._id == this.myForm.value.ou._id)
        if (test.length > 0) {
          temp.push(e)
        }
      }
    });

    if (temp.length <= 0) {
      temp = this.templates.find((obj: any) => obj.ou === null)
    } else {
      temp = temp[0]
    }

    console.log('id', this.myForm.value.ou._id, '===>this.templates', temp, "new=>", this.templates);

    this.selectedTemplete = temp;


    temp.fields.sort((a: any, b: any) => {
      if (a.priority && b.priority) {
        return a.priority - b.priority;
      } else {
        return 0;
      }
    })

    this.fields = temp?.fields.map((item: any) => {
      return {
        label: item.name,
        type: item._id,
        data: '',
        item_Id: null,
        item_Field: null,
      };
    });

    this.templetModel = true;
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }



  // Get icon of the filed
  getIcon(id: string) {
    let icon = this.selectedTemplete.fields.find((item: any) => {
      return item._id == id;
    }).icon;
    return 'pi pi-' + icon;
  }

  //Get Type of the filed
  getFiledType(id: string) {
    let type = this.selectedTemplete.fields.find((item: any) => {
      return item._id == id;
    }).type.name;
    return type
  }


  // Get icon of the filed for licenses
  getLicIcon(id: any) {
    let icon = this.dataFileds.find((item: any) => {
      return item.type._id == id;
    }).icon;
    return 'pi pi-' + icon;
  }

  //Get Type of the filed for licenses
  getFiledTypeLicenses(id: string) {
    let type = this.dataFileds.find((item: any) => {
      return item.type._id == id;
    }).type.name;
    return type
  }

  preview() {
    // validating All fields
    this.fields
    this.message = undefined
    const data = this.myForm.value;
    if(!data.name){
      this.message = 'The title is required'
    }
    let error = this.fields.some((item:any) => item.data === "");
    if(error){
      this.message = 'All fields are required'
      return
    }
    this.finalData = {
      name: data.name,
      type: data.type,
      fields: this.fields,
      ous: data.ou,
    };
    this.previewModal = true;
  }

  // reset template
  reset() {
    this.myForm.get('type').patchValue('')
    this.fields = []
  }

  async onSubmit() {
    try {
      let data = this.constructData(this.myForm.value);
      
      //license type check
      
      // constructing log
      let logData: any = {
        status: 'PENDING',
        type: 'ADD SERVICE',
        after: data,
        ous: data.ous,
      }

      // Creating Update Log
      let res = await this.dataService.postData('content-update/', logData)

      // let res = await this.dataService.postData('data/', data);
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }

      // //Check if Approve Permission is granted
      let isOuPermission: boolean = await this.permissionService.checkOUPermissionByID('CONTENT_UPDATE_LOGS', 'r', data.ous)
      if (this.permissionService.hasPermission('CONTENT_APPROVE', 'a') && isOuPermission) {
        //Approving log
        logData._id = res.data._id
        logData.status = 'APPROVED'
        let res2 = await this.dataService.postData('content-update/approve', logData, 'PUT', false);
        if (res2.error) {
          this.messages = [
            { severity: 'error',  summary: this.translate('error'), detail: res.msg },
          ];
          return
        }
        // Clean data function
        let response = await this.dataService.getData("ou/clean");
      }

      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];

      console.log("Score end")


      //Reseting initials
      this.myForm.reset();
      this.fields = [];
      this.previewModal = false;
      this.templates = [];
      this.finalData = undefined;
      this.selectedTemplete = undefined;
    } catch (error) {
      console.log(error);
    }
  }

  constructData(data: any) {
    return {
      name: data.name,
      type: data.type._id,
      fields: this.fields,
      ous: data.ou._id,
    };
  }


  modalVisibilities: boolean[] = [];

  // Function to toggle modal visibility for a specific item.
  toggleModal(index: number) {
    this.modalVisibilities[index] = !this.modalVisibilities[index];
  }

  //service grt
  changeCurrentDataItem(dataItem: any, field: any, index: number) {
    field.data = dataItem
    this.toggleModal(index)
  }



    //tree Data
    //Get tree data and as per the  permission
  async getTreeData() {
    this.treeData = await this.permissionService.extractOUChildren('BULK_EDIT', 'a');

    this.selectedTreeData_orginal = cloneDeep(this.treeData)
    this.changeSelectedTag(null);
    
    console.log("===>test data d",this.selectedTreeData);
  }


  findNodeByName(data: any[], nodeName: any): any | undefined {
    for (const node of data) {
      // if (node._id === nodeName) {
      //   return node;
      // }

      if (node.children) {
        const result = this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }

    return undefined;
  }

  async changeSelectedTag(event: any) {
    console.log("change tag event", event);
    this.selectedTreeTags_current = {
      "label": "Content Related"
    };
    if (this.selectedTreeTags_current.label) {
      console.log("change tag event1", event,this.selectedTreeData);
      await this.filterTreeByTag("Content Related");
    } else {
      this.selectedTreeData = null;
    }

  }

  
  selectedTreeData : any = []
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  types: any[] = [];
  selectedTreeTags: MenuItem[] = [];

  filterTreeByTag(tag: string) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = []
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: []
        })
      });

      console.log("cloneitems.children", cloneitems);
      this.selectedTreeData = cloneDeep(cloneitems);

      console.log("cloneitems.children this.selectedTreeData", this.selectedTreeData);
    }
  }

  filterNodes(node: any, tag: string): any | null {
    // Recursively filter children nodes
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include the current node if it matches the tag or any of its children do
    if (node.tag === tag || (node.children && node.children.length > 0)) {
      return node;
    }

    return null; // Exclude this node from the result
  }

}
